// app/javascript/controllers/scroll_preservation_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["paginationLinks"]
  
  connect() {
    // Only attach event listener to the pagination section
    this.paginationLinksTarget.addEventListener("click", this.preserveScroll)
    this.element.addEventListener("turbo:before-fetch-request", this.saveScrollPosition)
    this.element.addEventListener("turbo:frame-render", this.restoreScrollPosition)
  }
  
  preserveScroll(event) {
    // Only target links with our specific class
    if (event.target.closest('a.pagy-pagination-link')) {
      event.preventDefault()
      // Rest of the code
    }
  }
  
  saveScrollPosition() {
    this.scrollPosition = window.scrollY
  }
  
  restoreScrollPosition() {
    window.scrollTo(0, this.scrollPosition)
  }
}